/* global axios */
import ApiClient from './ApiClient';

class EvolutionAPI extends ApiClient {
  constructor() {
    super('evolution/config', { accountScoped: true });
  }

  getConfig() {
    return axios.get(this.url);
  }

  updateConfig(payload) {
    return axios.put(this.url, payload);
  }
}

export default new EvolutionAPI();
